package gr.tech.GRAttestation.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import gr.tech.GRAttestation.util.Constants.FONT_FAMILY
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

//Status Failed 0, Warning, 1, Success 2, Vanilla 3
data class UserAlert @OptIn(ExperimentalUuidApi::class) constructor(
    val id: String = Uuid.random().toString(),
    val message: String,
    val status: Int,
    val durationMillis: Int = 3000
)

class AlertManager {
    private val _alerts = mutableStateListOf<UserAlert>()
    val alerts: List<UserAlert> get() = _alerts

    fun addAlert(alert: UserAlert) {
        _alerts.add(alert)
    }

    fun removeAlert(alert: UserAlert) {
        _alerts.remove(alert)
    }

    @Composable
    fun DisplayAlerts() {
        Column(
            modifier = Modifier
                .position(Position.Absolute)
                .zIndex(99)
                .top(54.px)
                .gap(6.px)
                .pointerEvents(PointerEvents.None),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            for (alert in alerts.toList()) {
                DisplayAlert(alert = alert) {
                    removeAlert(alert)
                }
            }
        }
    }
}

@Composable
fun DisplayAlert(
    alert: UserAlert,
    onDismiss: () -> Unit
) {
    var visible by remember { mutableStateOf(true) }
    var dismissed by remember { mutableStateOf(false) }

    val animationModifier = Modifier
        .transition(
            Transition.all(250.ms, timingFunction = TransitionTimingFunction.EaseInOut)
        )
        .opacity(if (dismissed) 0 else 1)
        .transform {
            translateY(
                if (dismissed) (0).px else (-20).px
            )
        }

    LaunchedEffect(Unit) {
        delay(alert.durationMillis.toLong())
        dismissed = true
        delay(250) // Let the animation finish
        visible = false
        onDismiss()
    }

    if (visible) {
        Div(
            attrs = Modifier
                .classNames("alert")
                .thenIf(
                    condition = alert.status == 0,
                    other = Modifier.classNames("alert-danger")
                )
                .thenIf(
                    condition = alert.status == 1,
                    other = Modifier.classNames("alert-warning")
                )
                .thenIf(
                    condition = alert.status == 2,
                    other = Modifier.classNames("alert-success")
                )
                .thenIf(
                    condition = alert.status == 3,
                    other = Modifier.classNames("alert-secondary")
                )
                .position(Position.Sticky)
                .fontFamily(FONT_FAMILY)
                .then(animationModifier)
                .toAttrs(),
        ) {
            Text(alert.message)
        }
    }
}